import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppsRoutingModule } from './apps-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, AppsRoutingModule],
  exports: [],
})
export class AppsModule {}
